import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'


const validateName = (rule, value, callback) => {
    if (!validateChinese(value) || value.length > 30 || value.length < 1) {
        callback(new Error('客户状态名称为1-30位中文'))
    } else {
        callback();
    }
}

export const customerStatusTableOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "客户状态名称",
            prop: "name",
            placeholder: "请输入客户状态名称",
            search: true,
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                validator: validateName
            }]
        },{
            label: "是否提醒",
            prop: "isRemind",
            type: 'radio',
            dicData: DIC.YES_NO,
            rules: [
                {
                    required: true,
                    message: "请选择是否提醒"
                }
            ]
        },
        {
            label: "提醒时间",
            prop: "remindTime",
            placeholder: "如需提醒，请输入提醒时间",
            type: "input"
        },{
            label: "提醒的用户",
            prop: "remindUsers",
            type: 'checkbox',
            dicData: DIC.CUSTOMER_STATUS_USER_TYPE
        },
        {
            label: "提醒内容列表",
            prop: "contentList",
            hide: true,
            span: 24,
            solt: true,
            formsolt: true
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "状态",
            prop: "status",
            type: "radio",
            dicData: DIC.STATE,
            sortable: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "是否删除",
            prop: "deleteFlag",
            type: "radio",
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            dicData: DIC.DELETE_FLAG
        },
        {
            label: "备注",
            prop: "remarks",
            type: "textarea",
            span: 24,
            hide: true,
            max: 255
        }


    ]
};